module.exports = __webpack_public_path__ + "img/2_148.72a9e7b1.png";